// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export const enum SyncJobChangeReason {
    Onboarding = 'Onboarding',
    StatusUpdate = 'StatusUpdate',
    Update = 'Update',
    SubmissionApproved = 'SubmissionApproved',
    SubmissionRejected = 'SubmissionRejected',
    GroupSettings = 'GroupSettings'
}
